import { useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { lowerFirst, upperFirst } from "lodash";
import { Stack, Typography, Button } from "@financeable-com-au/financeable-ui";
// @ts-expect-error: ignoring as it is existing js file
import { setSubmissionModalOpen, applicationSelector } from "@/store/slices/applicationFormSlice";
import type { ApplicationFormSlice, ApplicationState } from "@/store/slices/types/applicationFormSlice";
import { useApplicationRouteType } from "@/components/SubmissionModal/hooks/useApplicationRouteType";

const SubmissionFulfilled = () => {
  const applicationRouteType = useApplicationRouteType();
  const formattedApplicationRouteType = upperFirst(applicationRouteType);
  const { submissionModal } = useSelector<ApplicationFormSlice, ApplicationState>(applicationSelector);
  const dispatch = useDispatch();

  const handleCloseSubmissionModal = () => {
    dispatch(setSubmissionModalOpen({ isOpen: false }));
  };

  const fulfilledAction = useMemo(() => {
    if (submissionModal.submissionType === "email") {
      return "Emailed";
    }
    return "Uploaded";
  }, [submissionModal.submissionType]);

  return (
    <>
      <Stack alignItems="center" rowGap={6} textAlign="center" padding={8}>
        <Stack rowGap={3}>
          <Typography component="h2" id="modal-title" level="title-md">
            {fulfilledAction} Successfully!
          </Typography>
          <Typography>
            Your {applicationRouteType} to{" "}
            <Typography textColor="text.primary" bold component="span">
              '{submissionModal.lender}'
            </Typography>{" "}
            was {lowerFirst(fulfilledAction)}.
          </Typography>
          {submissionModal.submission.applicationNo && (
            <Typography>
              You can refer to {applicationRouteType} number{" "}
              <Typography textColor="text.primary" bold component="span">
                {submissionModal.submission.applicationNo}
              </Typography>
              .
            </Typography>
          )}
        </Stack>
      </Stack>
      <Stack
        columnGap={2}
        alignItems="center"
        justifyContent="center"
        bgcolor="neutral.100"
        borderTop="1px solid"
        borderColor="neutral.200"
        paddingX={8}
        paddingY={5}
        flexDirection="row"
      >
        <Button variant="primary" onClick={handleCloseSubmissionModal}>
          See {formattedApplicationRouteType}
        </Button>
      </Stack>
    </>
  );
};

export { SubmissionFulfilled };
